<template>
    <div class="stopCarErrorBox">
        <div class="succeedImgBox">
            <img src="../../../assets/img/wxPay/sb.svg"/>
        </div>
        <div class="title">缴费成功</div>
        <div class="succeed">
            系统未接收缴费信息,抬杆失败,请到人工窗口处理
        </div>
        <!--<div class="fanHui" @click="rturnFn()">返回</div>-->
        <div class="wxts">
            <md-notice-bar
                    icon="warn"
                    scrollable
                    type="warning"
            >
                缴费成功，系统未接收缴费信息，抬杆失败，请到人工窗口处理
            </md-notice-bar>
        </div>
    </div>
</template>

<script>
    export default {
        name: "stopCarError"
    }
</script>

<style lang="scss" scoped>
    .stopCarErrorBox{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
        position: relative;
        .succeedImgBox{
            margin-top: 38%;

        }
        
        .succeed{
            width: 90%;
            font-size: 14px;
            margin-top: 20px;
            color: #f98600;
            letter-spacing: 1px;
        }
        .wxts{
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
        }
        .title{
            margin: 5px;
            color:#00C800 ;
        }
        .fanHui{
            width: 100px;
            height:40px;
            line-height: 40px;
            text-align: center;
            margin-top: 14%;
            font-size: 14px;
            border-radius: 4px;
            border: 1px solid #00C800;
        }
    }
</style>
